import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Navigate,
  Routes,
} from "react-router-dom";
import Loader from "./HomeLayout/Loader/Loader";
import DeshBoard from "./components/NewOnBoarding/DeshBoard";
import FinancialInformation from "./components/NewOnBoarding/Financial_Informartion/FinancialInformation";
import FinancialOverviewScreen from "./components/NewOnBoarding/Financial_Informartion/FinancialOverviewScreen";
import FinancingSolutionMainScreen from "./components/NewOnBoarding/Select_Product/FinancingSolutionMainScreen";
import UboDetail from "./components/NewOnBoarding/UboDetail";

const PendingComponent = React.lazy(() =>
  import("./components/PendingsComponent/PendingComponent")
);
const SettlementComponent = React.lazy(() =>
  import("./components/SettelementComponent/SettlementComponent")
);
const Requests = React.lazy(() =>
  import("./components/RequestComponent/Requests")
);
const UserLibrary = React.lazy(() =>
  import("./components/DocumentLibraryComponent/DocumentLibrary")
);
const UserCommonBackground = React.lazy(() =>
  import("./components/UserCommonBackground/UserCommonBackground")
);
const Home = React.lazy(() => import("./HomeComponent/Home"));
const BankDetails = React.lazy(() => import("./pages/BankDetails/BankDetails"));
const BuyerPlatformSetup = React.lazy(() =>
  import("./pages/BuyerPlatformSetup/BuyerPlatformSetup")
);
const CompanyDetails = React.lazy(() =>
  import("./pages/CompanyDetails/CompanyDetails")
);
const CreateRequest = React.lazy(() =>
  import("./pages/CreateRequest/CreateRequest")
);
const EditAccount = React.lazy(() => import("./pages/EditAccount/EditAccount"));
const UserProfile = React.lazy(() => import("./pages/UserProfile/UserProfile"));
const Document = React.lazy(() => import("./pages/Document/Document"));
const ComplianceDocuments = React.lazy(() => import("./pages/ComplianceDocuments/ComplianceDocuments"));
const Remittance = React.lazy(() =>
  import("./components/viewRemittance/viewRemittance")
);
const InvoiceVerify = React.lazy(() =>
  import("./pages/InvoiceVerify/InvoiceVerify")
);
const Monitor = React.lazy(() => import("./pages/Monitor/Monitor"));
const BankStatement = React.lazy(() => import("./pages/BankStatement"));
const CategoryList = React.lazy(() => import("./pages/Category/CategoryList"));
const ProductPage = React.lazy(() => import("./pages/Category/ProductPage"));
const TapPayment = React.lazy(() =>
  import("./pages/merchantRequest/tapPayment")
);
const Reports = React.lazy(() => import("./pages/Report/report"));
const UnAuthorized = React.lazy(() => import("./pages/unAuthorized"));
const UserManagments = React.lazy(() =>
  import("./components/UserManagmentComponent/UserManagment")
);
const AddUser = React.lazy(() =>
  import("./components/UserManagmentComponent/addUser")
);
const EditUser = React.lazy(() =>
  import("./components/UserManagmentComponent/editUser")
);
const Invoices = React.lazy(() =>
  import("./components/InvoiceComponent/Invoice")
);

const BankDetailsList = React.lazy(() => {
  return import("./components/NewOnBoarding/BankDetails/MyCompanyList");
});

const AddCompany = React.lazy(() => {
  return import("./components/NewOnBoarding/AddCompany/Company");
});

// const UboDetails = React.lazy(() => {
//   return import("./components/NewOnBoarding/Ubo/uboDetails");
// });

const BankGuarantee = React.lazy(() => {
  return import("./components/bankGuarantee/bankGuarantee");
});
const ParentContainerComponent = ({ socket }) => {
  let id = window.localStorage.getItem("_id");
  let accountStatus = window.localStorage.getItem("accountStatus");
  if (window.localStorage.getItem("_id")) {
    id = window.localStorage.getItem("_id");
  }
  const [progressRefreshKey, setProgressRefreshKey] = useState(0);

  const triggerProgressRefresh = () =>
    setProgressRefreshKey((prev) => prev + 1);
  useEffect(() => {
    // Check localStorage periodically or listen for storage changes
    const checkAccountStatus = () => {
      const newId = window.localStorage.getItem("_id");
      const newAccountStatus = window.localStorage.getItem("accountStatus");

      if (newId !== id) {
        id = newId;
      }
      if (newAccountStatus !== accountStatus) {
        accountStatus = newAccountStatus;
        // Force re-render by updating state
        setProgressRefreshKey((prev) => prev + 1);
      }
    };

    // Listen for storage changes
    window.addEventListener("storage", checkAccountStatus);

    // Also check periodically as a fallback
    const interval = setInterval(checkAccountStatus, 1000);

    return () => {
      window.removeEventListener("storage", checkAccountStatus);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/invoiceverify" element={<InvoiceVerify />} />
            <Route path="/monitor/:id/:token/:roleId/:email/:phone" element={<Monitor />} />
            {id != null ? (
              accountStatus == "Active" || accountStatus == "OnHold" ? (
                <>
                  <Route
                    path="/user"
                    element={<Home id={id} socket={socket} />}
                  />
                  <Route path="/" element={<Home id={id} socket={socket} />} />
                </>
              ) : (
                <>
                  <Route
                    path="/user"
                    element={
                      <DeshBoard
                        socket={socket}
                        progressRefreshKey={progressRefreshKey}
                        triggerProgressRefresh={triggerProgressRefresh}
                      />
                    }
                  >
                    <Route
                      path="bank-details"
                      element={
                        <BankDetailsList
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                    <Route
                      path="financial-info"
                      element={
                        <FinancialInformation
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                    <Route
                      path="select-product"
                      element={<FinancingSolutionMainScreen />}
                    />
                    <Route
                      index
                      element={
                        <AddCompany
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                  </Route>
                  <Route
                    path="/"
                    element={
                      <DeshBoard
                        socket={socket}
                        progressRefreshKey={progressRefreshKey}
                        triggerProgressRefresh={triggerProgressRefresh}
                      />
                    }
                  >
                    <Route
                      path="bank-details"
                      element={
                        <BankDetailsList
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                    <Route
                      path="financial-info"
                      element={
                        <FinancialInformation
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                    <Route
                      path="select-product"
                      element={<FinancingSolutionMainScreen />}
                    />
                    <Route
                      index
                      element={
                        <AddCompany
                          triggerProgressRefresh={triggerProgressRefresh}
                        />
                      }
                    />
                  </Route>
                </>
              )
            ) : (
              <>
                <Route path="/user" element={<UserCommonBackground />} />
                <Route
                  path="/user/createAccount/:extraData?"
                  element={<UserCommonBackground />}
                />
                <Route path="/:extraData?" element={<UserCommonBackground />} />
              </>
            )}

            <Route path="/user/tnc" element={<UserCommonBackground />} />
            <Route
              path="/user/SelectBuyerPlatform"
              element={<UserCommonBackground />}
            />
            <Route
              path="/user/pendings"
              element={<PendingComponent socket={socket} />}
            />
            <Route
              path="/user/settlements"
              element={<SettlementComponent socket={socket} />}
            />
            <Route
              path="/user/bank-guarantee-project"
              element={<BankGuarantee socket={socket} />}
            />
            <Route
              path="/user/requests"
              element={<Requests socket={socket} />}
            />
            <Route
              path="/user/document/library"
              element={<UserLibrary socket={socket} />}
            />
            <Route
              path="/user/bankDetails"
              element={<BankDetails socket={socket} />}
            />
            <Route
              path="/user/setupbuyerplatform/:selectedBP"
              element={<BuyerPlatformSetup />}
            />
            <Route path="/user/companyDetails" element={<CompanyDetails />} />
            <Route
              path="/user/createRequest"
              element={<CreateRequest socket={socket} />}
            />
            <Route
              path="/user/documents"
              element={<Document socket={socket} />}
            />
            <Route path="/user/bankstatement" element={<BankStatement />} />
            <Route path="/userProfile" element={<UserProfile />} />
            <Route path="/userProfile/account" element={<EditAccount />} />
            <Route
              path="/userProfile/companyDetail"
              element={<CompanyDetails />}
            />
            <Route path="/userProfile/bankDetail" element={<BankDetails />} />
            <Route path="/userProfile/documents" element={<Document />} />
            <Route
              path="/userProfile/setUpBuyerPlatform/:selectedBP"
              element={<BuyerPlatformSetup />}
            />
            <Route
              path="/user/Remittance"
              element={<Remittance socket={socket} />}
            />
            <Route path="/user/partnerslist" element={<CategoryList />} />
            <Route path="/user/partners/:id" element={<ProductPage />} />
            <Route
              path="/user/tapPayment"
              element={<TapPayment socket={socket} />}
            />
            <Route path="/user/reports" element={<Reports />} />
            <Route path="/user/UnAuthorized" element={<UnAuthorized />} />
            <Route
              path="/user/management"
              element={<UserManagments socket={socket} />}
            />
            <Route path="/user/addUser" element={<AddUser />} />
            <Route
              path="/user/editUser/:id"
              element={<EditUser socket={socket} />}
            />
            <Route
              path="/user/invoices"
              element={<Invoices socket={socket} />}
            />
            <Route path="*" element={<Navigate to="/user" replace />} />
            <Route
              path="/user/compliance-documents"
              element={<ComplianceDocuments socket={socket} />}
            />
          </Routes>
        </React.Suspense>
      </Router>
    </div>
  );
};

export default ParentContainerComponent;
